import { Navigate, Outlet, useLocation } from "react-router-dom";
import { FullscreenLoader } from "@breakingthelines/design-system";

import { hasRequiredRole, useAuthStore } from "@/stores/auth-store";
import type { AdminRole } from "@/types/auth";

interface ProtectedRouteProps {
  minRole?: AdminRole;
}

export function ProtectedRoute({ minRole = "admin" }: ProtectedRouteProps) {
  const location = useLocation();
  const { user, isLoading } = useAuthStore();

  if (isLoading) {
    return <FullscreenLoader label="Loading session" />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasRequiredRole(user.role, minRole, user.roles)) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
